"use strict";

var toUsfmActions = {
  startDocument: [{
    description: "Set up environment",
    test: () => true,
    action: _ref => {
      var {
        context,
        workspace
      } = _ref;
      workspace.usfmBits = [''];

      for (var [key, value] of Object.entries(context.document.metadata.document).filter(kv => !['tags', 'properties', 'bookCode'].includes(kv[0]))) {
        if (['toc', 'toca'].includes(key)) {
          key += '1';
        }

        workspace.usfmBits.push("\\".concat(key, " ").concat(value, "\n"));
      }

      ;
    }
  }],
  blockGraft: [{
    description: "Follow block grafts",
    test: _ref2 => {
      var {
        context
      } = _ref2;
      return ['title', 'heading', 'introduction'].includes(context.sequences[0].block.subType);
    },
    action: environment => {
      var target = environment.context.sequences[0].block.target;

      if (target) {
        environment.context.renderer.renderSequenceId(environment, target);
      }
    }
  }],
  inlineGraft: [{
    description: "Follow inline grafts",
    test: () => false,
    action: environment => {
      var target = environment.context.sequences[0].element.target;

      if (target) {
        environment.context.renderer.renderSequenceId(environment, target);
      }
    }
  }],
  startParagraph: [{
    description: "Output paragraph tag",
    test: () => true,
    action: _ref3 => {
      var {
        context,
        workspace
      } = _ref3;
      workspace.usfmBits.push("\n\\".concat(context.sequences[0].block.subType.split(':')[1], "\n"));
    }
  }],
  endParagraph: [{
    description: "Output nl",
    test: () => true,
    action: _ref4 => {
      var {
        workspace
      } = _ref4;
      workspace.usfmBits.push("\n");
    }
  }],
  text: [{
    description: "Output text",
    test: () => true,
    action: _ref5 => {
      var {
        context,
        workspace
      } = _ref5;
      var text = context.sequences[0].element.text;
      workspace.usfmBits.push(text);
    }
  }],
  mark: [{
    description: "Output chapter or verses",
    test: () => true,
    action: _ref6 => {
      var {
        context,
        workspace
      } = _ref6;
      var element = context.sequences[0].element;

      if (element.subType === 'chapter') {
        workspace.usfmBits.push("\n\\c ".concat(element.atts['number'], "\n"));
      } else if (element.subType === 'verses') {
        workspace.usfmBits.push("\\v ".concat(element.atts['number'], " "));
      }
    }
  }],
  endDocument: [{
    description: "Build output",
    test: () => true,
    action: _ref7 => {
      var {
        workspace,
        output
      } = _ref7;
      output.usfm = workspace.usfmBits.join('');
    }
  }]
};
module.exports = toUsfmActions;